import React from 'react';
import doctors from '../../../../../../../../../../../../services/doctors/index';
import users from '../../../../../../../../../../../../services/users/index';
import diagnostics from '../../../../../../../../../../../../services/diagnostics/index';
import { format } from 'date-fns';
import { from24To12 } from '../../../../../../../../../../../../services/utilities';
const esLocale = require('date-fns/locale/es')

export default class AppointmentRow extends React.Component {
    state = {
        doctor: null,
        user: null,
        diagnostic: null,
        loading: true
    }

    get appointment() {
        return this.props.appointment;
    }

    componentWillReceiveProps(nextProps) {
        let dateString = format(
            new Date(Number(nextProps.appointment.date)),
            "DD/MM/YYYY",
            {locale: esLocale},
        )
        this.setState({dateString: dateString})
        doctors.findOne({_id: nextProps.appointment.doctor}, (err, doctor) => {
            if(doctor)
                this.setState({doctor: doctor})
            else
                this.setState({doctor: "Otro"})
        })
        users.findOne({_id: nextProps.appointment.user}, (err, user) => {
            this.setState({user: user})
        })
        if(this.props.appointment.old)
            this.setState({diagnostic: {
                name: this.props.appointment.diagnostic
            }})
        else
            diagnostics.findOne({_id: nextProps.appointment.diagnostic}, (err, diagnostic) => {
                this.setState({diagnostic: diagnostic})
            })
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    render() {
        if(!this.state.user || !this.state.doctor || !this.state.diagnostic)
            return <tr><td><a className="button is-loading">Loading</a></td></tr>

        return (
            <tr onClick={() => this.props.details(this.appointment._id)}>
                <td>{this.state.diagnostic.name}</td>
                <td>
                    {this.state.doctor == "Otro" ?
                        this.state.doctor :
                        `${this.state.doctor.name} ${this.state.doctor.lastname}`
                    }
                </td>
                <td>{this.state.dateString}</td>
                <td>{from24To12(this.appointment.time)}</td>
                <td>{this.state.user.userName}</td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patient-details/scenes/patient-tabs/components/appointments/components/appointment/index.js